import { render, staticRenderFns } from "./reports-page-wrapper.vue?vue&type=template&id=1b1e3ca9&scoped=true&"
import script from "./reports-page-wrapper.vue?vue&type=script&lang=js&"
export * from "./reports-page-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./reports-page-wrapper.vue?vue&type=style&index=0&id=1b1e3ca9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1e3ca9",
  null
  
)

export default component.exports